import { apiRequest } from "@/services/api-client";
import { DexListOutput, DexDetailsOutput, DexClaimInput, DexClaimOutput } from "types/web-app";

export const getDexList = () =>
  apiRequest<DexListOutput>("/dex/list");

export const getDexDetails = (set_id: string) =>
  apiRequest<DexDetailsOutput>(`/dex/details?set_id=${encodeURIComponent(set_id)}`);

export const claimDexReward = (input: DexClaimInput) =>
  apiRequest<DexClaimOutput>("/dex/claim", { method: "POST", body: JSON.stringify(input) });
